import React, { useEffect } from 'react'
import PageHeader from '../../components/PageHeader'
import {
  useGetAppStatisticsQuery,
  useGetAppStatusStatisticsQuery,
} from '../../redux/services/DashboardService'
import { useGetSelectDriversQuery } from '../../redux/services/DriverService'
import { useGetExpenceStatisticsQuery } from '../../redux/services/ExpenceService'
import { useGetJobStatisQuery } from '../../redux/services/JobService'
import { useGetPaymentStatisticsQuery } from '../../redux/services/PaymentService'
const DashboardPage = () => {
  const { refetch } = useGetSelectDriversQuery()
  const { data: data1, refetch: refetch1 } = useGetJobStatisQuery()
  const { data: data2, refetch: refetch2 } = useGetExpenceStatisticsQuery()
  const { data: data3, refetch: refetch3 } = useGetPaymentStatisticsQuery()
  const { data: data4, refetch: refetch4 } = useGetAppStatusStatisticsQuery()
  const { data: data5, refetch: refetch5 } = useGetAppStatisticsQuery()

  const job = data1?.response?.data
  const expense = data2?.response?.data
  const payment = data3?.response?.data
  const statusStatistics = data4?.response?.data
  const statistics = data5?.response?.data

  useEffect(() => {
    refetch()
    refetch1()
    refetch2()
    refetch3()
    refetch4()
    refetch5()
  }, [])
  return (
    <>
      <PageHeader name='Dashboard' />

      <>
        {/* CONTAINER */}
        <div className='main-container container-fluid'>
          {/* Start::Row-1 */}
          <div className='row pb-5'>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='row'>
                    <div className='col-lg-4 col-md-6 col-sm-6'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Total Trips</p>
                              <span className='fs-5'>${job?.total?.amount || 0}</span>
                              <span className='fs-12 text-success ms-1'>
                                {job?.total?.total || 0}
                              </span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-primary-transparent text-primary'>
                                <i className='fe fe-dollar-sign fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-6'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Total Expenses </p>
                              <span className='fs-5'>${expense?.total?.amount || 0}</span>
                              <span className='fs-12 text-success ms-1'>
                                {expense?.total?.total || 0}
                              </span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-secondary-transparent text-secondary'>
                                <i className='fe fe-shopping-cart fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-6'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Total Due Payouts</p>
                              <span className='fs-5'>${payment?.total?.amount || 0}</span>
                              <span className='fs-12 text-success ms-1'>
                                {payment?.total?.total || 0}
                              </span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-warning-transparent text-warning'>
                                <i className='fe fe-credit-card fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-lg-12 mb-4'>
                  <div className='row'>
                    <div className='col-lg-4'>
                      <ul className='list-group'>
                        <li className='list-group-item active fw-bold'>Daily Statistics</li>
                        <li className='list-group-item list-group-item-action'>
                          1. &nbsp; Daily Trips
                          <span className='badgetext badge text-black bg-primary-transparent rounded-pill'>
                            ${job?.daily?.amount || 0} ({job?.daily?.total || 0})
                          </span>
                        </li>
                        <li className='list-group-item list-group-item-action'>
                          1. &nbsp; Daily Expenses
                          <span className='badgetext badge text-black bg-primary-transparent rounded-pill'>
                            ${expense?.daily?.amount || 0} ({expense?.daily?.total || 0})
                          </span>
                        </li>
                        <li className='list-group-item list-group-item-action'>
                          1. &nbsp; Daily Payouts
                          <span className='badgetext text-black badge bg-primary-transparent rounded-pill'>
                            ${payment?.daily?.amount || 0} ({payment?.daily?.total || 0})
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className='col-lg-4'>
                      <ul className='list-group'>
                        <li className='list-group-item bg-warning text-white fw-bold'>
                          Weekly Statistics
                        </li>
                        <li className='list-group-item list-group-item-action'>
                          1. &nbsp; Weekly Trips
                          <span className='badgetext badge text-black bg-primary-transparent rounded-pill'>
                            ${job?.weekly?.amount || 0} ({job?.weekly?.total || 0})
                          </span>
                        </li>
                        <li className='list-group-item list-group-item-action'>
                          2. &nbsp; Weeekly Expenses
                          <span className='badgetext badge text-black bg-primary-transparent rounded-pill'>
                            ${expense?.weekly?.amount || 0} ({expense?.weekly?.total || 0})
                          </span>
                        </li>
                        <li className='list-group-item list-group-item-action'>
                          3. &nbsp; Weekly Payouts
                          <span className='badgetext badge text-black bg-primary-transparent rounded-pill'>
                            ${payment?.weekly?.amount || 0} ({payment?.weekly?.total || 0})
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div className='col-lg-4'>
                      <ul className='list-group'>
                        <li className='list-group-item bg-danger text-white fw-bold'>
                          Monthly Statistics
                        </li>
                        <li className='list-group-item list-group-item-action'>
                          1. &nbsp; Monthly Trips
                          <span className='badgetext badge text-black bg-primary-transparent rounded-pill'>
                            ${job?.monthly?.amount || 0} ({job?.monthly?.total || 0})
                          </span>
                        </li>
                        <li className='list-group-item list-group-item-action'>
                          2. &nbsp; Monthly Expenses
                          <span className='badgetext badge text-black bg-primary-transparent rounded-pill'>
                            ${expense?.monthly?.amount || 0} ({expense?.monthly?.total || 0})
                          </span>
                        </li>
                        <li className='list-group-item list-group-item-action'>
                          3. &nbsp; Monthly  Payouts
                          <span className='badgetext badge text-black bg-primary-transparent rounded-pill'>
                            ${payment?.monthly?.amount || 0} ({payment?.monthly?.total || 0})
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12'>
                  <div className='card'>
                    <div className='card-header justify-content-between'>
                      <h6 className='card-title flex-grow-1 text-truncate me-3'>
                        Applications Statistics
                      </h6>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12'>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-6 col-xxl-6'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Submitted</p>
                              <span className='fs-5'>{statistics?.submitted || 0}</span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-primary-transparent text-primary'>
                                <i className='fe fe-upload fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-6 col-xxl-6'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Reject</p>
                              <span className='fs-5'>{statistics?.Reject || 0}</span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-danger-transparent text-danger'>
                                <i className='fe fe-x-circle fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-6 col-xxl-6'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Approved</p>
                              <span className='fs-5'>{statistics?.Approved || 0}</span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-success-transparent text-success'>
                                <i className='fe fe-check-circle fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-6 col-xxl-6'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Revision</p>
                              <span className='fs-5'>{statistics?.Revision || 0}</span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-warning-transparent text-warning'>
                                <i className='fe fe-repeat fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-12'>
                      <div className='card'>
                        <div className='card-header justify-content-between'>
                          <h6 className='card-title flex-grow-1 text-truncate me-3'>
                            Driver Statistics
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-6 col-xxl-4'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Active</p>
                              <span className='fs-5'>{statusStatistics?.active || 0}</span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-info-transparent text-info'>
                                <i className='fe fe-user-check fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-6 col-xxl-4'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Terminated</p>
                              <span className='fs-5'>{statusStatistics?.terminate || 0}</span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-dark-transparent text-dark'>
                                <i className='fe fe-user-x fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-6 col-xxl-4'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='d-flex align-items-start'>
                            <div className='flex-grow-1'>
                              <p className='mb-0'>Leave</p>
                              <span className='fs-5'>{statusStatistics?.leave || 0}</span>
                            </div>
                            <div className='min-w-fit-content ms-3'>
                              <span className='avatar avatar-md br-5 bg-secondary-transparent text-secondary'>
                                <i className='fe fe-user-minus fs-18' />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-md-6 mx-auto bg-white text-center p-4 pt-0">
                        <img src={dashboardImage} alt="" />
                        <h2 className='mt-4 mb-3'>The CRM is under Development</h2>
                        <p className='mb-4 text-center'>We are constantly working on system development, Kindly be Patient.
                            We apologise for any inconvenience and this will be completed soon.</p>
                        <img src={Logo} alt="" width={160} />
                    </div> */}
          {/* End::Row-1 */}
        </div>
        {/* CONTAINER END */}
      </>
    </>
  )
}

export default DashboardPage
